// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'

// onboardingSteps.js
export const SAVE_ONBOARDING_FORM = 'SAVE_ONBOARDING_FORM';
export const SAVE_SUBSCRIPTION_PORTAL = 'SAVE_SUBSCRIPTION_PORTAL';
export const FETCH_ONBOARDING_STEPS_SUCCESS = 'FETCH_ONBOARDING_STEPS_SUCCESS';
export const FETCH_ONBOARDING_STEPS_FAILURE = 'FETCH_ONBOARDING_STEPS_FAILURE';
export const UPDATE_ONBOARDING_FORM = 'UPDATE_ONBOARDING_FORM';
export const UPDATE_SUBSCRIPTION_PORTAL = 'UPDATE_SUBSCRIPTION_PORTAL';
export const UPDATE_ONBOARDING_DATA = 'UPDATE_ONBOARDING_DATA';
export const SET_PENDING_SUBSCRIPTION = 'SET_PENDING_SUBSCRIPTION';
export const CLEAR_PENDING_SUBSCRIPTION = 'CLEAR_PENDING_SUBSCRIPTION';

// onboarding.js
export const SET_ONBOARDING_STEPS = 'SET_ONBOARDING_STEPS';
export const UPDATE_ONBOARDING_STEP = 'UPDATE_ONBOARDING_STEP';

// crisp.js
export const SET_WEBSITE_ID = 'SET_WEBSITE_ID';



// mealLogs.js
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS'
export const SET_RECENT_MEALS = 'SET_RECENT_MEALS'

// dailyDashboard.js
export const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA'
export const UPDATE_DASHBOARD_DATA = 'UPDATE_DASHBOARD_DATA'
export const ADD_ITEM = 'ADD_ITEM'
export const UPDATE_ITEM = 'UPDATE_ITEM'
export const REMOVE_ITEM = 'REMOVE_ITEM'
export const SET_SHOW_MACROS = 'SET_SHOW_MACROS'
export const SET_SHOW_RECOMMENDATIONS_MODAL = 'SET_SHOW_RECOMMENDATIONS_MODAL'
export const TOGGLE_RECOMMENDATION_COMPLETION = 'TOGGLE_RECOMMENDATION_COMPLETION'

// articles.js
export const SET_ARTICLES = 'SET_ARTICLES'
export const SET_LOADING = 'SET_LOADING'
export const SET_ERROR = 'SET_ERROR'

// reports.js
export const SET_NUTRITIONAL_ANALYTICS = 'SET_NUTRITIONAL_ANALYTICS'
export const SET_HABIT_REPORT = 'SET_HABIT_REPORT'
export const SET_INSIGHTS_REPORTS = 'SET_INSIGHTS_REPORTS'
export const SET_REPORT_DATES = 'SET_REPORT_DATES'

// periods.js
export const SET_PERIOD_DATES = 'SET_PERIOD_DATES'
export const SET_PERIOD_ANALYSIS = 'SET_PERIOD_ANALYSIS'
export const SET_LOADING_PERIODS = 'SET_LOADING_PERIODS'
export const SET_LOADING_ANALYSIS = 'SET_LOADING_ANALYSIS'
export const SET_LAST_FETCHED_PERIODS = 'SET_LAST_FETCHED_PERIODS'
export const SET_LAST_ANALYSIS_FETCHED = 'SET_LAST_ANALYSIS_FETCHED'
export const ADD_PERIOD_DATES = 'ADD_PERIOD_DATES'
export const REMOVE_PERIOD_DATES = 'REMOVE_PERIOD_DATES'
export const UPDATE_PERIOD_DATES = 'UPDATE_PERIOD_DATES'
export const CLEAR_PERIOD_DATES = 'CLEAR_PERIOD_DATES'
export const CLEAR_PERIOD_ANALYSIS = 'CLEAR_PERIOD_ANALYSIS'

// symptoms.js
export const SET_SYMPTOM_LOGS = 'SET_SYMPTOM_LOGS'
export const SET_SYMPTOM_LOG_FOR_DATE = 'SET_SYMPTOM_LOG_FOR_DATE'
export const REMOVE_SYMPTOM_LOG_FOR_DATE = 'REMOVE_SYMPTOM_LOG_FOR_DATE'
export const SET_LOADING_SYMPTOMS = 'SET_LOADING_SYMPTOMS'
export const SET_DATE_LOADING = 'SET_DATE_LOADING'
export const SET_LAST_FETCHED_FOR_DATE = 'SET_LAST_FETCHED_FOR_DATE'
export const CLEAR_SYMPTOM_LOGS = 'CLEAR_SYMPTOM_LOGS'

// purchases.js
export const START_PURCHASE_LOADING = 'START_PURCHASE_LOADING'
export const STOP_PURCHASE_LOADING = 'STOP_PURCHASE_LOADING'
export const START_RESTORE_LOADING = 'START_RESTORE_LOADING'
export const STOP_RESTORE_LOADING = 'STOP_RESTORE_LOADING'
export const ADD_OR_UPDATE_PRODUCT = 'ADD_OR_UPDATE_PRODUCT'
export const SET_PURCHASE_SUCCESS_MESSAGE = 'SET_PURCHASE_SUCCESS_MESSAGE'
export const SET_PURCHASE_ERROR_MESSAGE = 'SET_PURCHASE_ERROR_MESSAGE'
export const ACK_PURCHASE = 'ACK_PURCHASE'
export const SET_READY = 'SET_READY'
export const SET_SUBSCRIPTION_STATUS = 'SET_SUBSCRIPTION_STATUS'
export const SET_SUBSCRIPTION_CHECK_DATE = 'SET_SUBSCRIPTION_CHECK_DATE'

// camera.js
export const SET_CAMERA_STOPPED = 'SET_CAMERA_STOPPED'

